import {getCommonContent} from './commonContent'

// TODO: get rid of this in separate PR
export const useCommonContent = () => getCommonContent()
